export const Breakpoints = {
  small: 768,
  medium: 992,
  large: 1280,
  xlarge: 1440
}